import React, { Component } from 'react';
import { getPolicy } from '../contentful';
import marked from 'marked';
import TitleBar from './TitleBar';
import { Helmet } from 'react-helmet';

class Policy extends Component {
    state = {
        text: ''
    }

    componentDidMount() {
        getPolicy().then(data => this.setState({ text: data[0].fields.content }))
    }

    getMarkdownText() {
        var rawMarkup = marked(this.state.text, { sanitize: true });
        return { __html: rawMarkup };
    }

    render() {
        return (
            <>
                <Helmet>
                    <title>Lucille Graham Trust || Policy & Guidelines for Grants. </title>
                    <meta
                        name="description"
                        content="The Lucille Graham Trust focusses on music and music-related projects in the Greater London area, offer grants to musical education, research, music composition and performances."
                    />
                    <link
                        rel="canonical"
                        href="https://www.lucillegrahamtrust.org.uk/policy"
                    />
                </Helmet>
                <TitleBar title="Policy & Guidelines" />
                <div className="content">
                    <div style={{ textAlign: 'justify' }} dangerouslySetInnerHTML={this.getMarkdownText()} />
                </div>
            </>
        )
    }
}

export default Policy
